<script setup>
import ContentHeader from '@/Components/Content/Header/index.vue'; 
import Button from '@/Components/Button.vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { THEMES } from '@/constants';

const props = defineProps({
  career: {
    type: Object,
    required: true,
  },
  page: {
    type: String,
    required: true,
  },
});

const contextPage = usePage();
const context = computed(() => contextPage.props?.context);
const theme = context.value.theme;

const btnVariant = (theme) => {
  return {
    [THEMES.STUDY_AUS]: 'primary',
    [THEMES.STUDY_MELB]: 'secondary',
    [THEMES.STUDY_QLD]: 'primary',
  }[theme];
};
</script>

<template>
  <ContentHeader>
    <template #title>
      {{ career.name }}
    </template>
    <template #actions>
      <li v-if="page == 'courses'" class="h-fit mb-0">
        <Button
          class="w-full"
          type="link"
          :variant="btnVariant(theme)"
          :link="`/career/${career.slug}/${career.id}`"
        >
          View Career
        </Button>

      </li>
      <li v-if="page == 'career'" class="h-fit mb-0">
          <Button
            class="w-full"
          type="link"
          variant="secondary"
          :link="`/career/${career.slug}/${career.id}/courses`"
        >
          View Courses
        </Button>
      </li>
    </template>
  </ContentHeader>
</template>